import React, { useEffect, useState } from "react";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [newU, setNewU] = useState({ name: "", email: "", password: "", role: "user" });

  const load = () => api.get("/admin/users").then(r => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const toggleRole = async (u) => {
    try {
      await api.put(`/admin/users/${u.id}`, { role: u.role === "admin" ? "user" : "admin" });
      load();
      toast.success("Role diperbarui");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Hapus user ini?")) return;
    try { await api.delete(`/admin/users/${id}`); load(); toast.success("User dihapus"); }
    catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", newU);
      setShowAdd(false);
      setNewU({ name: "", email: "", password: "", role: "user" });
      load();
      toast.success("User berhasil ditambahkan");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  return (
    <div data-testid="admin-users-page">
      <div className="flex justify-between items-center mb-2">
        <h1 className="font-serif text-4xl text-[#1A1728]">User Management</h1>
        <button onClick={() => setShowAdd(true)} className="lumina-btn-primary py-2 px-4 text-sm flex items-center gap-2">
          <Plus className="w-4 h-4" /> Tambah User
        </button>
      </div>
      <p className="text-[#5C5870] mb-8">{users.length} terdaftar</p>
      
      {showAdd && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl p-8 max-w-md w-full relative">
            <button onClick={() => setShowAdd(false)} className="absolute top-6 right-6 text-gray-400 hover:text-black">
              <X className="w-5 h-5" />
            </button>
            <h2 className="text-xl font-serif mb-6">Tambah User Baru</h2>
            <form onSubmit={handleAdd} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Nama</label>
                <input required className="lumina-input w-full" value={newU.name} onChange={e => setNewU({...newU, name: e.target.value})} />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <input required type="email" className="lumina-input w-full" value={newU.email} onChange={e => setNewU({...newU, email: e.target.value})} />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Password</label>
                <input required minLength={6} type="password" className="lumina-input w-full" value={newU.password} onChange={e => setNewU({...newU, password: e.target.value})} />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Role</label>
                <select className="lumina-input w-full" value={newU.role} onChange={e => setNewU({...newU, role: e.target.value})}>
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              <button type="submit" className="lumina-btn-primary w-full mt-4">Simpan User</button>
            </form>
          </div>
        </div>
      )}

      <div className="lumina-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F1EBFA]/40 text-[#5C5870] text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-6 py-4">Nama</th>
              <th className="text-left px-6 py-4">Email</th>
              <th className="text-left px-6 py-4">Role</th>
              <th className="text-left px-6 py-4">Daftar</th>
              <th className="text-right px-6 py-4">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} className="border-t border-[#E2DFED]">
                <td className="px-6 py-4 font-medium">{u.name}</td>
                <td className="px-6 py-4 text-[#5C5870]">{u.email}</td>
                <td className="px-6 py-4"><span className={`px-3 py-1 rounded-full text-xs ${u.role === "admin" ? "bg-[#E8F0FA] text-[#6B4BA3]" : "bg-gray-100 text-gray-600"}`}>{u.role}</span></td>
                <td className="px-6 py-4 text-[#5C5870]">{new Date(u.created_at).toLocaleDateString("id-ID")}</td>
                <td className="px-6 py-4 text-right space-x-2">
                  <button onClick={() => toggleRole(u)} className="text-[#6B4BA3] hover:underline text-xs" data-testid={`toggle-role-${u.id}`}>Toggle Admin</button>
                  <button onClick={() => remove(u.id)} className="text-[#E57373] hover:underline text-xs" data-testid={`del-user-${u.id}`}>Hapus</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
